import React from 'react'

const L1ApproveReworkModalUI = ({
  title,
  onApproveClick,
  onReworkClick,
  onCancelClick,
  submitting,
  successMsg,
  errorList,
  loan
}) => {
  return (
    <div className="modal-backdrop" style={backdropStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3 style={{ marginTop: 0 }}>{title || 'L1 Approve/Rework'}</h3>

        {successMsg && (
          <div style={{
            color: 'green',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#d4edda',
            borderRadius: '4px',
            border: '1px solid #c3e6cb'
          }}>
            {successMsg}
          </div>
        )}

        {errorList && errorList.length > 0 && (
          <div style={{
            color: '#721c24',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#f8d7da',
            borderRadius: '4px',
            border: '1px solid #f5c6cb'
          }}>
            <strong>Error(s):</strong>
            <ul style={{ marginTop: '5px', marginBottom: '0', paddingLeft: '20px' }}>
              {errorList.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}

        {loan && (
          <div style={{
            fontSize: '13px',
            color: '#6c757d',
            marginBottom: '20px',
            padding: '8px',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px'
          }}>
            <strong>Loan:</strong> {loan.accountName} {loan.loanName || ''}
            <br />
            <strong>Loan ID:</strong> {loan.loanId}
          </div>
        )}

        <p style={{ marginBottom: '20px' }}>
          Please select an action for this disbursement checklist:
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button
            onClick={onApproveClick}
            disabled={submitting}
            style={{ ...optionButtonStyle, ...approveOptionStyle }}
          >
            ✓ Approve
          </button>
          <button
            onClick={onReworkClick}
            disabled={submitting}
            style={{ ...optionButtonStyle, ...reworkOptionStyle }}
          >
            ↻ Rework
          </button>
          <button
            onClick={onCancelClick}
            disabled={submitting}
            style={{ ...optionButtonStyle, ...cancelOptionStyle }}
          >
            ✕ Close this tab
          </button>
        </div>
      </div>
    </div>
  )
}

const backdropStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
}

const modalStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  minWidth: '450px',
  maxWidth: '600px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
}

const optionButtonStyle = {
  padding: '15px 20px',
  fontSize: '16px',
  cursor: 'pointer',
  border: '2px solid #ddd',
  borderRadius: '6px',
  backgroundColor: '#fff',
  textAlign: 'left',
  fontWeight: '500',
  transition: 'all 0.2s',
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
}

const approveOptionStyle = {
  borderColor: '#28a745',
  color: '#28a745'
}

const reworkOptionStyle = {
  borderColor: '#ffc107',
  color: '#856404'
}

const cancelOptionStyle = {
  borderColor: '#6c757d',
  color: '#6c757d'
}

export default L1ApproveReworkModalUI